<template>
  <section class="section-shaped my-0 pb-lg">
    <!-- <section class="section-hero section-shaped my-0"> -->
    <div class="shape shape-style-1 shape-dark">
      <span class="span-150"></span>
      <span class="span-50"></span>
      <span class="span-50"></span>
      <span class="span-75"></span>
      <span class="span-100"></span>
      <span class="span-75"></span>
      <span class="span-50"></span>
      <span class="span-100"></span>
      <span class="span-50"></span>
      <span class="span-100"></span>
    </div>
    <div class="container">
      <!-- <div class="d-flex justify-content-start col"> -->
      <div class="card bg-dark mt-3 mt-sm-3" style="width:400px">
        <div class="card-body">
          <p class="text-uppercase font-weight-bold">Rent unique hostels.</p>
          <form>
            <div class="form-group">
              <label for="exampleInputEmail1">Location</label>
              <base-input alternative placeholder="Where" addon-right-icon="ni ni-pin-3"></base-input>
            </div>
            <div class="form-group">
              <!-- Radio buttons -->
              <div class="mb-3">
                <small class="font-weight-bold">Occupancy</small>
              </div>
              <base-radio name="radio0" class="mb-3 d-inline pr-5" v-model="radio.radio1">Single</base-radio>

              <base-radio name="radio1" class="mb-3 d-inline pl-5" v-model="radio.radio1">Shared</base-radio>
            </div>
            <div class="form-group">
              <!-- Radio buttons -->
              <div class="mb-3">
                <small class="font-weight-bold">Number in a room</small>
              </div>
              <base-slider
                v-model="sliders.slider1"
                :range="{min: 1, max: 4}"
                :options="sliderOptions"
              ></base-slider>
              <p v-text="sliders.slider1 + ' person(s)'"></p>
            </div>
            <button type="submit" class="btn btn-default">Search</button>
          </form>
        </div>
      </div>
      <!-- </div> -->
    </div>
  </section>
</template>
<script>
export default {
  data() {
    return {
      radio: {
        radio1: "radio1",
        radio2: "radio3"
      },
      sliders: {
        slider1: 1,
        slider2: [150, 400]
      },
      sliderOptions: {
        step: 1
      }
    };
  }
};
</script>
<style>
</style>
